import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { OUTRO } from '@/utils/globals';

interface TestStepProps {
    isActive: boolean;
    title: string;
    duration?: number;
    isCompleted: boolean;
    max?: number;
    current?: number;
}

const TestStep: React.FC<TestStepProps> = ({ isActive, title, duration, isCompleted, max, current }) => {
    return (
        <div className="flex relative flex-row h-1/6">
            <div className="relative">
                {isCompleted ? (
                    <div className="w-[2px] ml-[10px] h-full bg-purple-800 ms-[10px]" />
                ) : (
                    <>
                        <div className="w-[2px] ml-[10px] h-full dark:bg-white bg-gray-800 ms-[10px]" />
                        {current !== undefined && max !== undefined && (
                            <div
                                style={{
                                    height: `${(current / max) * 100}%`,
                                }}
                                className="absolute top-[10px] left-0 ml-[10px] w-[2px] bg-purple-300 ms-[10px] z-0"
                            />
                        )}
                    </>
                )}
            </div>

            <div
                className={`absolute rounded-full w-[21px] h-[21px] ${
                    isCompleted ? 'dark:bg-white bg-gray-800' : 'bg-gray-200 border-gray-800 border'
                } flex text-white items-center justify-center text-xs`}
            >
                {isCompleted && <FontAwesomeIcon icon={faCheck} />}
            </div>

            <div className="flex flex-col">
                <div className="uppercase ms-[30px] text-lg leading-4 font-semibold">{title}</div>
                {duration !== undefined && (
                    <div className="uppercase ms-[30px] text-xs mt-3">~{duration} минут</div>
                )}
            </div>
        </div>
    );
};
const TestPath: React.FC<{ settings: any; currentSection: number; INTEREST_QUESTIONS: number; PERSONALITY_QUESTIONS: number; SKILL_QUESTIONS: number; LIFE_MEANING_QUESTIONS: number; interestQuestions: any[]; currentInterestIndex: number; personalityQuestions: any[]; currentPersonalityIndex: number; skillQuestions: any[]; currentSkillIndex: number; }> = ({ settings, currentSection, INTEREST_QUESTIONS, PERSONALITY_QUESTIONS, SKILL_QUESTIONS, LIFE_MEANING_QUESTIONS, interestQuestions, currentInterestIndex, personalityQuestions, currentPersonalityIndex, skillQuestions, currentSkillIndex }) => {
    const [isDrawerOpen, setDrawerOpen] = useState(false);
    const totalPercentage = interestQuestions.length +  personalityQuestions.length + skillQuestions.length + 10;
    let extraPercentage = 0;
    if (currentSection > LIFE_MEANING_QUESTIONS) {
        extraPercentage = 10;
    }
    if (currentSection > INTEREST_QUESTIONS) {
        currentInterestIndex = interestQuestions.length
    }
    if (currentSection > PERSONALITY_QUESTIONS) {
        currentPersonalityIndex = personalityQuestions.length
    }
    if (currentSection > SKILL_QUESTIONS) {
        currentSkillIndex = skillQuestions.length
    }
    const currentPercentage = currentInterestIndex + currentPersonalityIndex + currentSkillIndex + extraPercentage;

    return (
        <>
            <button
                className="md:hidden fixed bottom-0 right-0 p-4 bg-gray-300 dark:bg-dark-800 dark:text-white z-30 w-24 rounded-ss-md"
                onClick={() => setDrawerOpen(!isDrawerOpen)}
            >
                {isDrawerOpen ? (<FontAwesomeIcon className='font-bold text-lg' icon={faTimes} />):(<>{ (currentPercentage/totalPercentage*100).toFixed(0)}%</>)}
            </button>

             <div
                className={`fixed bottom-0 right-0 h-screen md:h-auto md:w-1/4 w-full bg-gray-200 dark:bg-dark-900 p-4 flex-col pt-[100px] z-20 transition-transform duration-300 transform ${
                    isDrawerOpen ? 'translate-y-0' : 'translate-y-full'
                } md:translate-y-0 md:relative md:flex md:translate-x-0`}
            >
                <TestStep
                    isActive={true}
                    title="Эхлэх"
                    isCompleted={true}
                />
                <TestStep
                    isActive={false}
                    title={settings?.interest_test_name || ''}
                    duration={settings?.interest_test_minute}
                    isCompleted={currentSection > INTEREST_QUESTIONS}
                    max={interestQuestions.length}
                    current={currentInterestIndex}
                />
                <TestStep
                    isActive={false}
                    title={settings?.personality_test_name || ''}
                    duration={settings?.personality_test_minute}
                    isCompleted={currentSection > PERSONALITY_QUESTIONS}
                    max={personalityQuestions.length}
                    current={currentPersonalityIndex}
                />
                <TestStep
                    isActive={false}
                    title={settings?.skill_test_name || ''}
                    duration={settings?.skill_test_minute}
                    isCompleted={currentSection > SKILL_QUESTIONS}
                    max={skillQuestions.length}
                    current={currentSkillIndex}
                />
                <TestStep
                    isActive={false}
                    title={settings?.life_meaning_test_name || ''}
                    duration={settings?.life_meaning_test_minute}
                    isCompleted={currentSection > LIFE_MEANING_QUESTIONS}
                />
                <div className="flex relative flex-col h-1/6">
                    <div className="flex flex-col">
                        <div className="uppercase ms-[30px] text-lg leading-4 font-semibold">Үр дүн</div>
                        <div className="uppercase ms-[30px] text-xs mt-3">~35 минут</div>
                    </div>

                    <div className="absolute rounded-full w-[21px] h-[21px] bg-gray-200 border-gray-800 border flex text-white items-center justify-center text-xs">
                    </div>

                    <div className="flex flex-col">
                        <div className="uppercase ms-[30px] text-md mt-3 whitespace-pre-line">
                            {settings?.result_subtitle_text}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TestPath;